import * as React from 'react';
import { Card } from './Card';

export const Content = ({ children }) => {
    return <Card>{children}</Card>;
};
